import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

// eslint-disable-next-line react/prop-types
const CellText = ({ style, text }) => {
  return (
    <Text style={style} wrap>
      {text}
    </Text>
  );
};

const borderColor = '#0059a3';
const styles = StyleSheet.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
    borderBottomColor: '#0059a3',
    borderBottomWidth: 0.5,
    fontStyle: 'bold',
  },
});

const ReportTableRow = ({ columns, items }) => {
  const numberColumns = columns.length;
  const reservedWidths = columns.reduce(
    ([total, totalColumns], column) => {
      const percent = parseFloat(column.reportColumnWidth);
      const isNan = Number.isNaN(percent);
      // eslint-disable-next-line no-param-reassign
      total += isNan ? 0 : percent;
      // eslint-disable-next-line no-param-reassign
      totalColumns += isNan ? 0 : 1;
      return [total, totalColumns];
    },
    [0, 0]
  );

  const [totalReservedWidth, totalReservedColumns] = reservedWidths;
  const reservedColumnWidth = totalReservedWidth / totalReservedColumns;
  const regularColumnWidth =
    (100 - totalReservedWidth) / (numberColumns - totalReservedColumns);

  // rows
  const rows = items.map((item) => (
    <View style={styles.row} key={`${item.id}-${item.jobId}-column`}>
      {columns.map((column) => {
        return (
          <CellText
            key={`${item.id}-${item.jobId}-${column.accessor}`}
            style={{
              borderRightColor: borderColor,
              textAlign: 'left',
              paddingRight: 8,
              width: `${
                typeof column.reportColumnWidth === 'undefined'
                  ? regularColumnWidth
                  : reservedColumnWidth
              }%`,
            }}
            text={item[column.accessor]}
          />
        );
      })}
    </View>
  ));
  return <>{rows}</>;
};

ReportTableRow.defaultProps = {
  columns: [],
  items: [],
};

ReportTableRow.propTypes = {
  columns: PropTypes.array,
  items: PropTypes.array,
};

export default ReportTableRow;
